<template>
    <v-card-text class="narrow-container">
        <v-text-field
            ref="twoFACode"
            v-model="twoFA.code"
            :error-messages="twoFA.$errors.code"
            label="Enter 2FA Code"
            outlined
            type="text"
            @blur="twoFA.validate('code')"
            @input="delete twoFA.$errors.code"
            @keyup.native.enter="on2FALogin"
        />

        <v-btn block color="primary" depressed large rounded @click="on2FALogin" class="mb-12">
            Log In
        </v-btn>

        <router-link :to="{ name: 'LoginWith2FARecovery', params: { email, password } }"
                     class="frontpage-link text-center d-block text-decoration-underline"
        >
            Don't have access to the phone?
        </router-link>
    </v-card-text>
</template>

<script>
import * as rules from "vuelidate/lib/validators";

export default {
    name: "LoginWith2FA",

    created() {
        if (!this.$route.params.email || !this.$route.params.password) {
            this.$router.push({ name: 'login' });
        }

        this.email = this.$route.params.email;
        this.password = this.$route.params.password;

        this.$nextTick(() => {
            this.$refs.twoFACode.$el.querySelector('input').focus();
        });
    },

    data() {
        return {
            email: null,
            password: null,
            twoFA: new Form(this, 'twoFA', {
                code: null,
            }),
        }
    },

    validations: {
        twoFA: {
            code: { required: rules.required, minLength: rules.minLength(6), numeric: rules.numeric },
        },
    },

    methods: {
        async on2FALogin() {
            if (!this.twoFA.validate()) {
                return;
            }

            let response = await this.$store.dispatch('Auth/login2FA', {
                one_time_password: this.twoFA.code,
                email: this.email,
                password: this.password
            })

            if (response == 'wrong-account') {
                this.$snackbar(`You tried to login with a fylm.ai Lite account. <a href="${window.FYLM_LITE_APP_URL}" style="color: white; text-decoration: underline">Please open fylm.ai Lite</a> and login again.`, "warning");
            }

            if (response?.status == 403) {
                this.$snackbar(`Incorrect two factor authentication code.`, "error");
                this.twoFA.code = '';
            }
        },
    }
}
</script>